const CARRIER_URL_MAP: Record<string, (trackingNo: string) => string> = {
  ups: (t) => `https://www.ups.com/track?tracknum=${encodeURIComponent(t)}`,
  fedex: (t) => `https://www.fedex.com/fedextrack/?trknbr=${encodeURIComponent(t)}`,
  usps: (t) => `https://tools.usps.com/go/TrackConfirmAction?tLabels=${encodeURIComponent(t)}`,
  dhl: (t) =>
    `https://www.dhl.com/us-en/home/tracking/tracking-express.html?submit=1&tracking-id=${encodeURIComponent(t)}`,
};

export function getTrackingUrl(carrier: string, trackingNo: string): string | null {
  const key = carrier.toLowerCase().trim();
  const builder = CARRIER_URL_MAP[key];
  return builder ? builder(trackingNo) : null;
}

/**
 * BC's inbound tracking rows (repair and core returns) never carry a shipping
 * agent, so the carrier is inferred from the tracking number's format. Our
 * inbound labels are UPS ("1Z" + 16 characters) or FedEx (12 or 15 digits).
 * Returns null when the format is not recognized.
 */
function inferCarrier(trackingNo: string): string | null {
  const t = trackingNo.replace(/\s+/g, '');
  if (/^1Z[0-9A-Z]{16}$/i.test(t)) return 'UPS';
  if (/^\d{12}$/.test(t) || /^\d{15}$/.test(t)) return 'FedEx';
  if (/^9[2-5]\d{18,20}$/.test(t)) return 'USPS';
  return null;
}

/** The carrier BC sent, or one inferred from the tracking number. */
export function resolveCarrier(carrier: string | undefined, trackingNo: string): string | null {
  return carrier?.trim() || inferCarrier(trackingNo);
}

const TRACKING_STATUS_LABELS: Record<string, string> = {
  pre_transit: 'Label created',
  in_transit: 'In transit',
  out_for_delivery: 'Out for delivery',
  delivered: 'Delivered',
  available_for_pickup: 'Ready for pickup',
  return_to_sender: 'Returning to sender',
  failure: 'Delivery issue',
};

/** Plain label for the carrier status BC stores, such as "pre_transit". */
export function formatTrackingStatus(status: string): string {
  const key = status.trim().toLowerCase();
  return TRACKING_STATUS_LABELS[key] ?? key.replace(/_/g, ' ');
}
